import React from 'react';
import ReactSelect from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

const tabSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: '40px',
        borderRadius: '2px',
        borderColor: state.isFocused ? '#FF5733' : '#e5e7eb',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(255,87,51,0.1)' : 'none'
    }),
    dropdownIndicator: (provided) => ({ ...provided, color: '#FF5733' }),
    indicatorSeparator: () => ({ display: 'none' }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
};

const ExpenseTabs = ({ tabConfigs, activeTab, setActiveTab, counts, countsLoading, getTabCount }) => {
    const tabOptions = tabConfigs.map(tab => ({
        value: tab.key,
        label: `${tab.label} (${countsLoading ? '...' : getTabCount(tab.key)})`
    }));

    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
            {/* Desktop: Tab buttons per copilot pattern */}
            <div className="hidden md:flex gap-2 overflow-auto border-b border-gray-200 pb-0">
                {tabConfigs.map(tab => {
                    const count = getTabCount(tab.key);
                    return (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={`px-6 py-3 font-semibold text-base transition-all border-b-2 -mb-px ${activeTab === tab.key ? 'border-[#FF5733] text-[#FF5733]' : 'border-transparent text-gray-600 hover:text-gray-800'}`}
                        >
                            <span className="hidden md:inline">{tab.label}</span>
                            <span className={`ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs rounded-full ${activeTab === tab.key ? 'bg-orange-100 text-[#FF5733]' : 'bg-gray-100 text-gray-600'}`}>
                                {countsLoading ? (
                                    <FontAwesomeIcon icon={faSyncAlt} spin className="text-[#FF5733]" />
                                ) : count}
                            </span>
                        </button>
                    );
                })}
            </div>

            {/* Mobile: react-select dropdown */}
            <div className="md:hidden w-full">
                <label htmlFor="expenses-tab-select" className="sr-only">Select expense view</label>
                <ReactSelect
                    inputId="expenses-tab-select"
                    aria-label="Select expense view"
                    options={tabOptions}
                    value={tabOptions.find(o => o.value === activeTab) || tabOptions[0]}
                    onChange={(opt) => setActiveTab(opt?.value ?? 'all')}
                    styles={tabSelectStyles}
                    isSearchable={false}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    menuPosition="fixed"
                />
            </div>
        </div>
    );
};

export default ExpenseTabs;
